import React from 'react';
import { useIntl } from 'react-intl';
import { Utils } from 'billon-ui';
import CustomToolTip from '../../ui/CustomToolTip';
import * as Styled from './styled';

const { Icon } = Utils;

const StatusTooltip = ({ id, label, delay }) => {
  const { formatMessage } = useIntl();

  const formattedLabel = label && label !== '' && formatMessage({ id: label });

  return (
    <CustomToolTip
      id={'StatusTooltip-' + id}
      trigger={<Icon name="info-circle" color="grey" fontSize="18px" />}
      delay={delay}
    >
      <Styled.ToolTipContentWrapper>
        {formattedLabel}
      </Styled.ToolTipContentWrapper>
    </CustomToolTip>
  );
};

export default StatusTooltip;
